var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwx-sign",style:(_vm.signStyle)},[_c('div',{style:(_vm.signDivStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }